<template>
    <div style="display: flex">
        <div :class=" (option.value != checkedOption ? 'option-uncheck option': 'option-checked option') " v-for="option in options" :key="option.value" @click="clickOption(option)">{{option.text}}</div>
    </div>
</template>
<script>
export default {
    props: ['options'], // {text: '', value: '' }
    data() {
        return {
            checkedOption: '',
        }
    },
    watch: {
        checkedOption: function (newVal, oldVal) {
            this.$emit('on-change', this.checkedOption);
        }
    },
    methods: {
        clickOption(option) {
            this.checkedOption = option.value;
        }

    }
}
</script>

<style lang="scss" scoped>
.option {
    font-size: 14px;
      border: 2px solid #c4c1c1;
    margin-right: 20px;
    padding: 5px;
    -moz-user-select: none; /*火狐*/
    -webkit-user-select: none; /*webkit浏览器*/
    -ms-user-select: none; /*IE10*/
    -khtml-user-select: none; /*早期浏览器*/
    user-select: none;
}

.option:hover {
    border: 2px solid #ff8800;
    cursor: pointer;
}

.option-uncheck {
     border: 2px solid #c4c1c1;
}

.option-checked {
    border: 2px solid #ff8800;

    background: #fbe4cd;
}
</style>